export default {
    MANUAL_NONE: -1, // 无响应
    MANUAL_SINGLE: 0, // 单人接待
    MANUAL_GROUP: 1, // 分组接待
    MANUAL_ROBOT: 4, // 机器人接待
    MANUAL_NAV: 5, // 自助导航
    MANUAL_RULE: 6, // 高级分配规则
    MANUAL_STAFFLIST: 12, // 客服列表
};
